import React, { useEffect, useState } from "react";
import {
  Modal,
  Typography,
  Empty,
  List,
  Avatar,
  Divider,
  Col,
  Row,
  Spin,
  Card,
  Statistic,
  Tag
} from "antd";
import {
  CalendarOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  HomeOutlined,
  TeamOutlined
} from "@ant-design/icons";
import { getParticipantesAgregados } from "../../services/EcasParticipante/ecaParticipanteService";

const { Text } = Typography;

export default function ViewParticipantsModal({ isOpen, onClose, eca }) {
  const [participantesECA, setParticipantesECA] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !eca?.oid) return;

    const fetchParticipantes = async () => {
      setLoading(true);
      try {
        const data = await getParticipantesAgregados(eca.oid);
        setParticipantesECA(data);
      } catch (error) {
        console.error("Error al cargar participantes de la ECA:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchParticipantes();
  }, [isOpen, eca]);

  if (!eca) return null;

  return (
    <Modal
      title={
        <span>
          <TeamOutlined style={{ marginRight: 8 }} />
          Participantes de: {eca.nombre}
        </span>
      }
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={800}
      styles={{ body: { maxHeight: "75vh", overflowY: "auto", padding: 24 } }}
    >
      <Row gutter={[16, 16]} justify="center" style={{ marginBottom: 24 }}>
  <Col xs={24} sm={12} md={6}>
    <Card
      style={{
        textAlign: "center",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Statistic
        title="Total Participantes"
        value={participantesECA.length}
        valueStyle={{ color: "#3f8600" }}
        prefix={<TeamOutlined />}
      />
    </Card>
  </Col>

  <Col xs={24} sm={12} md={12}>
    <Card
      style={{
        textAlign: "center",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Statistic
        title="Tipo de Temática"
        valueRender={() => {
          const estadoMap = {
            1: { label: "Técnico", color: "blue" },
            2: { label: "Ambiental", color: "green" },
            3: { label: "Socioempresarial", color: "volcano" },
            4: { label: "Comercial", color: "purple" },
            5: { label: "DHAA", color: "orange" },
            6: { label: "Enfoque Diferencial", color: "cyan" },
          };

          const ids =
            typeof eca.tipo_estado === "string"
              ? eca.tipo_estado.split(",").map((i) => parseInt(i.trim()))
              : Array.isArray(eca.tipo_estado)
              ? eca.tipo_estado
              : [];

          return (
            <div>
              {ids.length === 0 ? (
                <Tag color="default">Sin temática</Tag>
              ) : (
                ids.map((id) => {
                  const info = estadoMap[id] || {
                    label: "Desconocido",
                    color: "default",
                  };
                  return (
                    <Tag key={id} color={info.color}>
                      {info.label}
                    </Tag>
                  );
                })
              )}
            </div>
          );
        }}
      />
    </Card>
  </Col>

  <Col xs={24} sm={12} md={6}>
    <Card
      style={{
        textAlign: "center",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Statistic
        title="Fecha de sesión ECA"
        value={new Date(eca.fechaCreacion).toLocaleDateString("es-ES")}
        prefix={<CalendarOutlined />}
      />
    </Card>
  </Col>
</Row>


      <Divider orientation="left" plain style={{ marginTop: 24 }}>
        Lista de Participantes
      </Divider>

      {loading ? (
        <Spin />
      ) : participantesECA.length === 0 ? (
        <Empty description="No hay participantes registrados" />
      ) : (
        <List
          size="small"
          dataSource={participantesECA}
          renderItem={(p, index) => (
            <List.Item
              key={p.oid}
              style={{
                border: "1px solid #f0f0f0",
                borderRadius: 8,
                padding: 8,
                marginBottom: 8
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <Avatar
                  size="small"
                  style={{ backgroundColor: "#1890ff", fontSize: 12 }}
                >
                  {index + 1}
                </Avatar>
                <div style={{ flex: 1 }}>
                  <Text style={{ fontSize: 13 }} strong>
                    {p.nombre_participante}{" "}
                    <Tag color="cyan">
                      Documento: {p.numero_identificacion}
                    </Tag>
                  </Text>
                  <div style={{ marginTop: 6, fontSize: 13, color: "#666" }}>
                    <div style={{ fontSize: 12, color: "#666" }}>
                      <HomeOutlined /> {p.departamento} |{" "}
                      <EnvironmentOutlined /> {p.municipio} |{" "}
                      <PhoneOutlined /> {p.telefono}
                    </div>
                  </div>
                </div>
              </div>
            </List.Item>
          )}
        />
      )}
    </Modal>
  );
}
